import CircleStyle from "ol/style/Circle.js";
import Fill from "ol/style/Fill.js";
import Stroke from "ol/style/Stroke.js";
import Style from "ol/style/Style.js";
import Text from "ol/style/Text.js";

const SENSOR_COLORS = Object.freeze({
  online: "#16a34a",
  offline: "#dc2626",
});

const styleCache = new Map();

export const sensorMarkerStyle = (
  status = "offline",
  selected = false,
  code = ""
) => {
  const normalizedStatus = status === "online" ? "online" : "offline";
  const label = String(code || "").trim();
  const cacheKey = `${normalizedStatus}:${selected}:${label}`;
  if (styleCache.has(cacheKey)) return styleCache.get(cacheKey);

  const style = new Style({
    image: new CircleStyle({
      radius: selected ? 9 : 6,
      fill: new Fill({ color: SENSOR_COLORS[normalizedStatus] }),
      ...(selected
        ? { stroke: new Stroke({ color: "#facc15", width: 3 }) }
        : {}),
    }),
    text: new Text({
      text: label,
      font: "600 12px system-ui, sans-serif",
      offsetX: 14,
      offsetY: -10,
      textAlign: "left",
      fill: new Fill({ color: "#ffffff" }),
      stroke: new Stroke({ color: "rgba(17, 24, 39, 0.9)", width: 3 }),
    }),
    zIndex: selected ? 100 : 50,
  });
  styleCache.set(cacheKey, style);
  return style;
};

export const sensorStyleFunction = (feature) =>
  sensorMarkerStyle(
    feature.get("status"),
    feature.get("selected") === true,
    feature.get("code")
  );
